module.exports = __webpack_public_path__ + "assets/img/banner-3-stop-watch-mask.svg";